import axios from "axios";
import { FechasPrioridad } from "../types";
import { axiosInstances } from "../components/AxiosManager/AxiosInstances";

interface PrioridadApiBody {
  tienePrioridad: boolean;
  mensajePrioridad: string;
  fechasPrioridad: FechasPrioridad;
  debeMostrarContador: boolean;
  debeConsultarCupos: boolean;
}

export interface PrioridadApiResponse extends PrioridadApiBody {
  /** Reloj local al resolverse el request; se compara contra la hora de servidor para calibrar el countdown. */
  recibidoEnMs: number;
}

export const updatePrioridad = async (prioridad: boolean | null): Promise<PrioridadApiResponse> => {
  const { data }: { data: PrioridadApiBody } = await axiosInstances.prioridad.post(
    `/api/prioridad?r=${Math.random().toString()}`,
    { prioridad }
  );
  return { ...data, recibidoEnMs: Date.now() };
};
